import React, { useState, useEffect, useRef } from 'react';

// Detect react-snap prerender
const isPrerender =
  typeof navigator !== 'undefined' &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('ReactSnap') !== -1;

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

const stats = [
  { target: 240, suffix: '+', label: 'Acres', sublabel: 'Treated Annually' },
  { target: 40, suffix: '+', label: 'Years', sublabel: 'Since 1984' },
  { target: 5, suffix: '', label: 'Industries', sublabel: 'Served' },
  { target: 5, suffix: '', label: 'Regions', sublabel: 'Across BC' },
];

const CounterNumber = ({ target, suffix, started }) => {
  const [count, setCount] = useState(isPrerender ? target : 0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!started || isPrerender) return;

    const duration = 2000;
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutCubic(progress);

      setCount(Math.round(easedProgress * target));

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [started, target]);

  return (
    <span className="text-4xl md:text-5xl font-bold text-white font-sans">
      {count}{suffix}
    </span>
  );
};

const StatsCounter = () => {
  const containerRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node || isPrerender) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="py-12 md:py-16 my-4">
      <div className="bg-green-900 rounded-lg mx-auto max-w-4xl py-10 px-6 md:px-12 shadow-lg">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center">
          {stats.map((stat, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <CounterNumber
                target={stat.target}
                suffix={stat.suffix}
                started={hasStarted}
              />
              <span className="text-green-300 text-sm font-semibold uppercase tracking-wider mt-1">
                {stat.label}
              </span>
              <span className="text-green-400/70 text-xs">
                {stat.sublabel}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsCounter;
